import { SET_FEATURES } from "./constants";

export const setFeatures = features => ({
  type: SET_FEATURES,
  payload: features
});
